module.exports = __webpack_public_path__ + "static/media/OpenSans-Light.09e00aa7.eot";